import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfp-back-button-small',
  templateUrl: './back-button-small.component.html',
  styleUrls: ['./back-button-small.component.scss']
})
export class BackButtonSmallComponent {
  @Input() label = '';

  constructor() {}
}
